"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeCollectionUpgrade = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var __1 = require("..");
var __2 = require("../..");
var collection_upgrade_action_1 = require("./collection.upgrade.action");
var IkeCollectionUpgrade = /** @class */ (function () {
    function IkeCollectionUpgrade(collections, targetForm) {
        this.validations = {};
        this.actions = {};
        this.collections = collections;
        this.targetForm = targetForm;
    }
    /** Add a migration action for a field, eg drop, replace */
    IkeCollectionUpgrade.prototype.addAction = function (action) {
        if (this.actions[action.fieldId]) {
            throw new Error('Duplicate action fieldId: ' + action.fieldId);
        }
        this.actions[action.fieldId] = collection_upgrade_action_1.IkeCollectionUpgradeActionFactory.createAction(action);
        return this;
    };
    IkeCollectionUpgrade.prototype.process = function (log) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var output, _i, _a, oldCollection, newCollection, validations;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        output = [];
                        _i = 0, _a = this.collections;
                        _b.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        oldCollection = _a[_i];
                        newCollection = __2.IkeModel.Collection.read(__2.IkeModel.Collection.write(oldCollection), this.targetForm, oldCollection.loader);
                        return [4 /*yield*/, newCollection.ready()];
                    case 2:
                        _b.sent();
                        return [4 /*yield*/, this.processSubForm(oldCollection, newCollection, log.child({ collectionId: oldCollection.id }))];
                    case 3:
                        _b.sent();
                        output.push(newCollection);
                        _b.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 1];
                    case 5:
                        validations = Object.keys(this.validations);
                        if (validations.length > 0) {
                            return [2 /*return*/, { result: 'failure', fields: validations.map(function (c) { return _this.validations[c]; }) }];
                        }
                        return [2 /*return*/, { result: 'success', collections: output }];
                }
            });
        });
    };
    IkeCollectionUpgrade.prototype.findMatchingField = function (field, oldSubForm, newSubForm) {
        // If the action maps the field then use that
        var action = this.actions[field.id];
        if (action != null) {
            return action.targetFieldId;
        }
        // Attempt to look for a matching field by display name
        var sourceMatches = oldSubForm.fields.filter(function (f) { return f.displayName === field.displayName && f.type === field.type; });
        if (sourceMatches.length > 1) {
            // Multiple source fields, skip
            return null;
        }
        var matches = newSubForm.fields.filter(function (f) { return f.displayName === field.displayName && f.type === field.type; });
        if (matches.length !== 1) {
            // Multiple target fields, skip
            return null;
        }
        return matches[0].id;
    };
    IkeCollectionUpgrade.prototype.getAction = function (oldField) {
        return this.actions[oldField.schema.id];
    };
    IkeCollectionUpgrade.prototype.processSubForm = function (oldSubForm, newSubForm, log) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var failures, _i, _a, schemaField, oldField, targetFieldId, action, newDropField, isActionProcessed, targetField, newField, _b, _c, oldInstance, newInstance, res, isActionProcessed, oldFormVersion, newFormVersion, isIPFUpgrade;
            var _d, _e, _f, _g, _h, _j, _k, _l;
            return tslib_1.__generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        failures = [];
                        _i = 0, _a = oldSubForm.schema.fields;
                        _m.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        schemaField = _a[_i];
                        oldField = oldSubForm.getField(schemaField.id);
                        if (!oldField.hasValue()) {
                            return [3 /*break*/, 6];
                        }
                        // handle undefined yes/no field
                        if (oldField.schema.type === core_api_1.IkeFieldType.YES_NO && oldField.displayValue === 'undefined') {
                            return [3 /*break*/, 6];
                        }
                        targetFieldId = schemaField.id;
                        action = this.getAction(oldField);
                        // Handle 'drop' as a special case when target form does not have field defined
                        if (action != null && !action.requiresTargetField) {
                            if (newSubForm.hasField(targetFieldId)) {
                                newDropField = newSubForm.getField(targetFieldId);
                                isActionProcessed = action.process(oldField, newDropField, log);
                                if (isActionProcessed) {
                                    log.trace({ oldFieldId: oldField.id, newFieldId: newDropField.id, action: action.reason }, 'Applied action');
                                }
                            }
                            return [3 /*break*/, 6];
                        }
                        // Attempt to find the mapping for a missed field
                        if (!newSubForm.schema.hasField(schemaField.id)) {
                            targetFieldId = this.findMatchingField(schemaField, oldSubForm.schema, newSubForm.schema);
                            if (targetFieldId == null) {
                                log.warn({ fieldId: schemaField.id }, 'Unable to find field mapping');
                                this.validations[schemaField.id] = { reason: 'missing', fieldId: schemaField.id, fieldName: schemaField.displayName };
                                return [3 /*break*/, 6];
                            }
                            if (oldField.schema.type !== core_api_1.IkeFieldType.FORM) {
                                targetField = newSubForm.getField(targetFieldId);
                                targetField.Mutator.copy(oldField);
                            }
                        }
                        newField = newSubForm.getField(targetFieldId);
                        // field types have changed... TODO handle this
                        if (newField.schema.type !== oldField.schema.type) {
                            log.error({ oldFieldId: schemaField.id, newFieldId: newField.id, oldType: oldField.schema.type, newType: newField.schema.type }, 'Mapping invalid types');
                            throw new Error('Cannot map between types');
                        }
                        if (!(__1.CollectionModelFieldSubForm.isSubFormField(oldField) && __1.CollectionModelFieldSubForm.isSubFormField(newField))) return [3 /*break*/, 5];
                        _b = 0, _c = oldField.value;
                        _m.label = 2;
                    case 2:
                        if (!(_b < _c.length)) return [3 /*break*/, 5];
                        oldInstance = _c[_b];
                        newInstance = this.getOrCreateSubformInstance(newField, oldInstance.instanceId);
                        return [4 /*yield*/, this.processSubForm(oldInstance, newInstance, log)];
                    case 3:
                        res = _m.sent();
                        if (res.length > 0) {
                            failures = failures.concat(res);
                        }
                        _m.label = 4;
                    case 4:
                        _b++;
                        return [3 /*break*/, 2];
                    case 5:
                        if (action != null && action.process != null) {
                            isActionProcessed = action.process(oldField, newField, log);
                            if (isActionProcessed) {
                                log.trace({ oldFieldId: oldField.id, newFieldId: newField.id, action: action.reason }, 'Applied action');
                                return [3 /*break*/, 6];
                            }
                        }
                        if (newField.displayValue !== oldField.displayValue) {
                            oldFormVersion = (_g = (_f = (_e = (_d = oldSubForm.schema.getForm().metadata).getIkePoleForeman) === null || _e === void 0 ? void 0 : _e.call(_d)) === null || _f === void 0 ? void 0 : _f.formVersion) !== null && _g !== void 0 ? _g : 1;
                            newFormVersion = (_l = (_k = (_j = (_h = this.targetForm) === null || _h === void 0 ? void 0 : _h.metadata) === null || _j === void 0 ? void 0 : _j.getIkePoleForeman) === null || _k === void 0 ? void 0 : _k.call(_j)) === null || _l === void 0 ? void 0 : _l.formVersion;
                            isIPFUpgrade = ((oldField.schema.id === 'ipf_serviceCommunicationsCable' || oldField.schema.id === 'ipf_servicePowerConductor') &&
                                newFormVersion !== undefined &&
                                oldFormVersion < 3 && newFormVersion >= 3);
                            if (isIPFUpgrade) {
                                newField.Mutator.truncatedCopy(oldField);
                            }
                            else {
                                log.error({ oldFieldId: schemaField.id, oldDisplay: oldField.displayValue, newDisplay: newField.displayValue }, 'Display miss match');
                                this.addReplaceValue(schemaField, oldField.displayValue);
                            }
                        }
                        _m.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 1];
                    case 7: return [2 /*return*/, failures];
                }
            });
        });
    };
    IkeCollectionUpgrade.prototype.getOrCreateSubformInstance = function (subform, instanceId) {
        var newInstance = subform.getInstance(instanceId);
        if (newInstance != null) {
            return newInstance;
        }
        subform.Mutator.create(instanceId);
        return subform.getInstance(instanceId);
    };
    IkeCollectionUpgrade.prototype.addReplaceValue = function (field, value) {
        var existing = this.validations[field.id] || { fieldId: field.id, fieldName: field.displayName, reason: 'replace', values: [] };
        if (existing.reason !== 'replace') {
            throw new Error('Missing and Replace: ' + field.id);
        }
        if (existing.values.indexOf(value) > -1) {
            return;
        }
        existing.values.push(value);
        this.validations[field.id] = existing;
    };
    return IkeCollectionUpgrade;
}());
exports.IkeCollectionUpgrade = IkeCollectionUpgrade;
//# sourceMappingURL=collection.upgrade.js.map